import React from "react";
import { Mail, Linkedin, Phone } from "lucide-react";
import { profile } from "../mock/mock";

const ClosingCTA = () => {
  const waUrl = `https://wa.me/${profile.phoneRaw}`;

  return (
    <section id="boards" className="py-24 lg:py-32 bg-ink text-ivory-50 relative grain-overlay overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ivory-50/70">
                For Boards, CEOs and Search Partners
              </span>
            </div>

            <h2 className="font-serif-display text-4xl lg:text-5xl leading-[1.05] font-light">
              Actively exploring senior executive mandates across the GCC.
            </h2>

            <p className="mt-8 text-ivory-50/75 leading-relaxed text-lg max-w-2xl">
              I'm actively exploring senior executive mandates across Operations, Technology, and
              Commercial leadership in the UAE, KSA and Oman. If your organization needs someone
              who can turn service operations into a growth engine, let's talk.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="space-y-3">
              <a
                href={`mailto:${profile.email}`}
                className="group flex items-center justify-between gap-4 px-6 py-5 bg-ivory-50 text-ink rounded-sm hover:bg-bronze hover:text-ivory-50 transition-colors"
              >
                <div>
                  <div className="text-[11px] uppercase tracking-[0.22em] opacity-60 mb-1">Email</div>
                  <div className="text-sm font-medium">{profile.email}</div>
                </div>
                <Mail className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>

              <a
                href={profile.linkedin}
                target="_blank"
                rel="noreferrer"
                className="group flex items-center justify-between gap-4 px-6 py-5 bg-ivory-50 text-ink rounded-sm hover:bg-bronze hover:text-ivory-50 transition-colors"
              >
                <div>
                  <div className="text-[11px] uppercase tracking-[0.22em] opacity-60 mb-1">LinkedIn</div>
                  <div className="text-sm font-medium">Connect on LinkedIn</div>
                </div>
                <Linkedin className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>

              <a
                href={waUrl}
                target="_blank"
                rel="noreferrer"
                className="group flex items-center justify-between gap-4 px-6 py-5 bg-ivory-50 text-ink rounded-sm hover:bg-bronze hover:text-ivory-50 transition-colors"
              >
                <div>
                  <div className="text-[11px] uppercase tracking-[0.22em] opacity-60 mb-1">
                    Call / WhatsApp
                  </div>
                  <div className="text-sm font-medium">{profile.phone}</div>
                </div>
                <Phone className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
